import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";

export default function Helplines() {
  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Телефоны доверия
      </h1>

      <h3 className="about-nii__title antiCorruption__title">
        Телефон доверия администрации губернатора <br></br>
        <br></br>+7 (343) 370-72-02
      </h3>

      <h3 className="about-nii__title antiCorruption__title">
        Телефон доверия Минздрава Свердловской области<br></br>
        <br></br>+7 (343) 312-00-03
      </h3>
    </section>
  );
}
